import NabDafInMemoryCacheStrategy from './nab-daf-in-memory';

export const getTokenCacheStrategy = () => {
	return {
		authTokenCacheStrategy: NabDafInMemoryCacheStrategy.getInstance(),
	};
};
